import { useMemo } from 'react';
import { getFiGrowthBook, useIsGrowthBookEnabled } from '../lib/growthbook';

/**
 * Kill switches for the supplements surfaces in the storefront. Both default to false so the
 * surfaces stay hidden unless GrowthBook explicitly turns them on (or an `fi_gb_ee_*` override
 * cookie forces them for QA). Outside a GrowthBookProvider (in-app webviews) they are always off.
 */
function useSupplementsFlag(featureName: string): boolean {
  const isGrowthBookEnabled = useIsGrowthBookEnabled();

  return useMemo(
    () => (isGrowthBookEnabled ? getFiGrowthBook().getFeatureValue<boolean>(featureName, false) : false),
    [isGrowthBookEnabled, featureName],
  );
}

/** Whether a completed hardware checkout should land on the supplements upsell instead of thank-you. */
export function usePostCheckoutSupplementsUpsellEnabled(): boolean {
  return useSupplementsFlag('ecom-supplements-post-checkout-upsell');
}

/** Whether the "Supplements" card is shown in the PLP keep-shopping carousel. */
export function usePlpSupplementsCardEnabled(): boolean {
  return useSupplementsFlag('ecom-supplements-plp-card');
}
